import { render, staticRenderFns } from "./newyearbiggift.vue?vue&type=template&id=ee33e54e&scoped=true&"
import script from "./newyearbiggift.vue?vue&type=script&lang=js&"
export * from "./newyearbiggift.vue?vue&type=script&lang=js&"
import style0 from "./newyearbiggift.vue?vue&type=style&index=0&id=ee33e54e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee33e54e",
  null
  
)

export default component.exports